import {postPasswordReset} from './passwordReset';

export const apiPasswordReset = {
  postPasswordReset,
};
